import { render, staticRenderFns } from "./realEstatePrices.vue?vue&type=template&id=ccd6e5b2&"
import script from "./realEstatePrices.vue?vue&type=script&lang=js&"
export * from "./realEstatePrices.vue?vue&type=script&lang=js&"
import style0 from "./realEstatePrices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports